// function showTrialInfo()
// { 
//     if (listArrays[allColumns.indexOf('counterTrial')][trialRow]!="na" && (listArrays[allColumns.indexOf('type')][trialRow]=="practice" || listArrays[allColumns.indexOf('type')][trialRow]=="test"  || listArrays[allColumns.indexOf('type')][trialRow]=="learn" ))
//     {
//     displayText("trialInfo",iBlock+"/"+nTrialsBlock[listBlockNo[trialRow]]);//display "trial i of n"
//     }
// }

function showTrialInfo()
{ 
    if (typeof stimOrderCounterTrial[trial] !== 'undefined' && (listArrays[allColumns.indexOf('type')][trialRow]=="practice" || listArrays[allColumns.indexOf('type')][trialRow]=="test"  || listArrays[allColumns.indexOf('type')][trialRow]=="learn" ))
    {
    displayText("trialInfo",stimOrderCounterTrial[trial]);//display "trial i of n"
    //show("content-title");//added by Daniel; why??
    }
}